var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1833 3.19896L13.6889 5.70451C13.7944 5.81007 13.7944 5.98229 13.6889 6.08785L7.62222 12.1545L5.04444 12.4406C4.7 12.4795 4.40833 12.1878 4.44722 11.8434L4.73333 9.26562L10.8 3.19896C10.9056 3.0934 11.0778 3.0934 11.1833 3.19896ZM15.6833 2.56285L14.3278 1.20729C13.9056 0.785069 13.2194 0.785069 12.7944 1.20729L11.8111 2.19062C11.7056 2.29618 11.7056 2.4684 11.8111 2.57396L14.3167 5.07951C14.4222 5.18507 14.5944 5.18507 14.7 5.07951L15.6833 4.09618C16.1056 3.67118 16.1056 2.98507 15.6833 2.56285ZM10.6667 10.5045V13.3323H1.77778V4.4434H8.16111C8.25 4.4434 8.33333 4.40729 8.39722 4.34618L9.50833 3.23507C9.71944 3.02396 9.56944 2.66562 9.27222 2.66562H1.33333C0.597222 2.66562 0 3.26285 0 3.99896V13.7767C0 14.5128 0.597222 15.1101 1.33333 15.1101H11.1111C11.8472 15.1101 12.4444 14.5128 12.4444 13.7767V9.3934C12.4444 9.09618 12.0861 8.94896 11.875 9.15729L10.7639 10.2684C10.7028 10.3323 10.6667 10.4156 10.6667 10.5045Z",
    fill: "#0923E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/edit-pencil.83801fc1a9498160e63f8e97930c6d02.svg";
export { ForwardRef as ReactComponent };